import * as Types from "../Constants/AllConstants";

export const CreateSmsPackageReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.SMS_PACKAGE_CREATE_REQUEST:
      return { loading: true };
    case Types.SMS_PACKAGE_CREATE_SUCCESS:
      return { loading: false, success: true, smsPackage: action.payload };
    case Types.SMS_PACKAGE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.SMS_PACKAGE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const UpdateSmsPackageReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.SMS_PACKAGE_UPDATE_REQUEST:
      return { loading: true };
    case Types.SMS_PACKAGE_UPDATE_SUCCESS:
      return { loading: false, success: true, smsPackage: action.payload };
    case Types.SMS_PACKAGE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.SMS_PACKAGE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const DeleteSmsPackageReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.SMS_PACKAGE_DELETE_REQUEST:
      return { loading: true };
    case Types.SMS_PACKAGE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.SMS_PACKAGE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const GetPagedSmsPackagesReducer = (state = { packages: [], pages: 0, page: 0 }, action) => {
  switch (action.type) {
    case Types.SMS_PACKAGE_PAGED_REQUEST:
      return { loading: true };
    case Types.SMS_PACKAGE_PAGED_SUCCESS:
      return {
        loading: false,
        packages: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.SMS_PACKAGE_PAGED_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const GetAllSmsPackagesReducer = (state = { packages: [] }, action) => {
  switch (action.type) {
    case Types.SMS_PACKAGE_LIST_REQUEST:
      return { loading: true };
    case Types.SMS_PACKAGE_LIST_SUCCESS:
      return { loading: false, packages: action.payload };
    case Types.SMS_PACKAGE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
